import { TriangleAlertIcon } from 'lucide-react';

import { Flex } from 'components/layout';
import { Typography } from 'components/typography';
import { Maybe } from 'types/UtilityTypes';
import {
  EmailProvider,
  EmailProviderDisplayName,
} from 'types/enums/EmailProvider';

type ExpiredEmailWarningProps = {
  emailProvider: Maybe<EmailProvider>;
  openExternalUrl: (url: string) => void;
  drumkitPortalUrl: string;
};

export const ExpiredEmailWarning = ({
  emailProvider,
  openExternalUrl,
  drumkitPortalUrl,
}: ExpiredEmailWarningProps) => {
  return (
    <Flex direction='col' gap='md' className='bg-warning-300 p-4 mt-3 mb-1'>
      <Flex direction='row' gap='sm' align='center'>
        <TriangleAlertIcon className='h-6 w-6' />
        <Typography variant='h5' weight='bold'>
          {emailProvider
            ? EmailProviderDisplayName[emailProvider]
            : 'Your email provider'}{' '}
          reported an issue.
        </Typography>
      </Flex>

      <Typography variant='body-xs' weight='medium'>
        <span
          onClick={() => openExternalUrl(`${drumkitPortalUrl}/relink`)}
          className='cursor-pointer text-info underline'
        >
          Click here
        </span>

        {
          ' to re-link your email account and re-enable AI suggestions for new emails.'
        }
      </Typography>
    </Flex>
  );
};
